import { imageCdnUrl } from '../../shared/constants/cdn.constants';
import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EVENT_SLUGS } from '../../features/events/event-details/event-slugs';

declare const bootstrap: any;

interface SchoolBrand {
  /** Full route path (with leading slash) whose header shows this school's logo. */
  path: string;
  name: string;
  logo: string;
}

// Fallback for schools that don't have their own dedicated white-logo asset yet.
const DEFAULT_SCHOOL_LOGO = imageCdnUrl('cdn/ghrus-logo.webp');

// Extend this list as more school microsites get their own pages.
const SCHOOL_BRANDS: SchoolBrand[] = [
  { path: '/schools/engineering', name: 'School of Engineering & Technology', logo: imageCdnUrl('cdn/school-engineering-white.webp') },
  { path: '/schools/pharmacy', name: 'School of Pharmacy', logo: imageCdnUrl('school/school-of-pharmacy-white.webp') },
  { path: '/schools/agricultural', name: 'School of Agricultural', logo: imageCdnUrl('cdn/school-agriculture-white.webp') },
  { path: '/schools/diploma-x-ray-technician', name: 'School of Paramedical Courses', logo: DEFAULT_SCHOOL_LOGO },
  { path: '/schools/science', name: 'School of Science', logo: imageCdnUrl('school/school-science.webp') },
  { path: '/schools/nursing', name: 'School of Nursing', logo: imageCdnUrl('school/school-nursing.webp') },
  { path: '/schools/management', name: 'School of Commerce & Management', logo: imageCdnUrl('school/school-managment.webp') },
  { path: '/schools/law', name: 'School of Law', logo: imageCdnUrl('school/schools-law.webp') },
  { path: '/schools/arts', name: 'School of Liberal Arts', logo: imageCdnUrl('school/schools-art.webp') }
];

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  readonly schools = SCHOOL_BRANDS;
  isSticky = false;
  schoolBrand: SchoolBrand | null = null;
  // Event detail pages live at the site root (e.g. /ganesh-utsav),
  // so routerLinkActive can't match them to Events.
  isEventPage = false;

  private routerSubscription?: Subscription;

  constructor(private elementRef: ElementRef<HTMLElement>, private router: Router) {}

  ngOnInit(): void {
    this.updateSchoolBrand(this.router.url);
    this.routerSubscription = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.updateSchoolBrand(event.urlAfterRedirects));
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.isSticky = window.scrollY > 80;
  }

  closeNavbar(): void {
    const navbarContent = this.elementRef.nativeElement.querySelector('#navbar-content');
    if (navbarContent?.classList.contains('show')) {
      bootstrap.Collapse.getOrCreateInstance(navbarContent).hide();
    }
  }

  private updateSchoolBrand(url: string): void {
    const path = url.split(/[?#]/)[0];
    const slug = path.replace(/^\/+|\/+$/g, '');
    this.isEventPage = (EVENT_SLUGS as readonly string[]).includes(slug);
    this.schoolBrand = SCHOOL_BRANDS.find(brand => path === brand.path || path.startsWith(brand.path + '/')) ?? null;
  }
}
